import { render, staticRenderFns } from "./EscortVerify.vue?vue&type=template&id=afc07dac"
import script from "./EscortVerify.vue?vue&type=script&lang=js"
export * from "./EscortVerify.vue?vue&type=script&lang=js"
import style0 from "./EscortVerify.vue?vue&type=style&index=0&id=afc07dac&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports